import React, { Component } from "react";
import { consumeApi } from "../js/helpers";

import {
  Block,
  Col,
  Row,
  Icon,
  Link,
  Button,
  Popup,
  Page,
  Navbar,
  NavRight,
} from "framework7-react";

import { Dom7 } from "framework7";

export default class ReferenciaUnicaConekta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: "",
      heightFeatures: "",
      uniqueReference: {},
      proveedor: "",
      urSelected: {},
      openReference: false,
    };
  }
  componentDidMount() {
    const { RU } = this.props;
    // if (RU.url.includes('enefevo')) {
    //     Dom7('#tiendasConekta').addClass("hidden")
    //     this.setState({ proveedor: 'Enefevo' })
    // }
    // else if (RU.url.includes('conekta')) {
    //     Dom7('#tiendasEnefevo').addClass("hidden")
    //     Dom7('#infoEnefevo').addClass("hidden")
    // }

    const height = parseInt(window.innerHeight * 0.6) + "px";
    const heightFeatures = parseInt(window.innerHeight * 0.8) + "px";
    this.setState({ height: height, heightFeatures: heightFeatures });
  }

  setReference = (provider) => {
    const { RU } = this.props;
    console.log(RU);
    let selected = RU.filter((ref) => ref.provider === provider);
    this.setState({ urSelected: selected[0], openReference: true });
  };

  render() {
    return (
      <>
        <Block>
          <Row className="aligner">
            <Col width="100" medium="80" small="95">
              <div id="features" className="divSection rowflex elevation-15">
                <Row className="divTitle">
                  <Col width="100" className="">
                    <Col width="85">Referencia Única de Pago</Col>
                  </Col>
                </Row>
                <Row>
                  <Col className="" width="100">
                    <Row
                      className="aligner"
                      style={{ fontSize: "1.4em", paddingLeft: "20px" }}
                    >
                      <Col width="90" className="">
                        La información de su <strong>referencia única</strong>{" "}
                        le ayudará a realizar sus pagos.
                      </Col>
                    </Row>
                    <Row className="textCenter">
                      <Col
                        width="100"
                        medium="33"
                        small="90"
                        className="aligner"
                      >
                        <Col width="100">
                          <div
                            className="logoOxxo"
                            onClick={(e) => this.setReference("CONEKTA")}
                          ></div>
                        </Col>
                        {/* <Row>
                                                <Block>
                                                    <Col width="100" className="alinger">
                                                        <Button fill>Holi</Button>
                                                    </Col>
                                                </Block>
                                            </Row> */}
                      </Col>
                      <Col
                        width="100"
                        medium="33"
                        small="90"
                        className="aligner"
                      >
                        <div
                          className="logoOnepay"
                          onClick={(e) => this.setReference("ONEPAY")}
                        ></div>
                      </Col>
                      <Col
                        width="100"
                        medium="33"
                        small="90"
                        className="aligner"
                      >
                        <div
                          className="logoSmart"
                          onClick={(e) => this.setReference("SMART")}
                        ></div>
                      </Col>
                    </Row>
                    <Row className="aligner" style={{ fontSize: "1.2em" }}>
                      <Col width="90" className="aligner">
                        <strong>{this.props.RU.reference}</strong>
                      </Col>
                    </Row>
                    <Row
                      className="aligner"
                      style={{ fontSize: "18px", paddingLeft: "20px" }}
                    >
                      <Col width="90" className="">
                        <p>
                          Paga con tu referencia única{" "}
                          <strong>{this.props.RU.provider}</strong> en
                          cualquiera de las siguientes cadenas:
                        </p>
                      </Col>
                    </Row>
                    <div id="tiendasConekta">
                      <Row>
                        <Col width="100">
                          <Row>
                            <Col
                              width="10"
                              medium="5"
                              small="15"
                              xsmall="15"
                              className="checkMarkRU"
                            >
                              <Icon f7="checkmark_alt_circle_fill"></Icon>
                            </Col>
                            <Col width="90" medium="95" small="85" xsmall="85">
                              OXXO
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col width="100">
                          <Row>
                            <Col
                              width="10"
                              medium="5"
                              small="15"
                              xsmall="15"
                              className="checkMarkRU"
                            >
                              <Icon f7="checkmark_alt_circle_fill"></Icon>
                            </Col>
                            <Col width="90" medium="95" small="85" xsmall="85">
                              Tiendas Onemobile
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col width="100">
                          <Row>
                            <Col
                              width="10"
                              medium="5"
                              small="15"
                              xsmall="15"
                              className="checkMarkRU"
                            >
                              <Icon f7="checkmark_alt_circle_fill"></Icon>
                            </Col>
                            <Col width="90" medium="95" small="85" xsmall="85">
                              Tiendas S*Mart
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                    <Row
                      className="aligner"
                      style={{ fontSize: "18px", paddingLeft: "20px" }}
                    >
                      <Col width="90" className="">
                        <p>
                          En estos establecimientos tus pagos se verán
                          reflejados de <strong>inmediato</strong>.
                        </p>
                      </Col>
                    </Row>
                    <Row
                      width=""
                      style={{ fontSize: "18px", paddingLeft: "20px" }}
                    >
                      <Col width="90" className="">
                        <p>Sigue los siguientes pasos:</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Visita uno de estos establecimientos
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Indica al Cajero que quieres realizar un Pago de
                            Servicio <strong>{this.state.proveedor}</strong>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col width="100">
                        <Row>
                          <Col
                            width="10"
                            medium="5"
                            small="15"
                            xsmall="15"
                            className="checkMarkRU"
                          >
                            <Icon f7="checkmark_alt_circle_fill"></Icon>
                          </Col>
                          <Col width="90" medium="95" small="85" xsmall="85">
                            Presenta al cajero el código de barras o el número
                            de tu referencia única
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Block>
        <Popup
          opened={this.state.openReference}
          onPopupClosed={() => this.setState({ openReference: false })}
        >
          <Page>
            <Navbar>
              <NavRight>
                <Link id="closePopup" popupClose>
                  X
                </Link>
              </NavRight>
            </Navbar>
            <Block>
              <Row className="Aligner">
                <Col
                  width="100"
                  style={{ paddingTop: "15px", paddingBottom: "15px" }}
                >
                  <Col width="90" className="Aligner">
                    <img
                      src={
                        "data:image/png;base64," + this.state.urSelected.image
                      }
                      width={"100%"}
                    ></img>
                  </Col>
                </Col>
                <Col className="aligner" width="100">
                                    {this.state.urSelected.provider === 'CONEKTA' ?
                                        <Row className="aligner" style={{ fontSize: "1.5em" }}>
                                            <Col width="90" className="aligner">
                                                <strong>{this.state.urSelected.reference}</strong>
                                            </Col>
                                        </Row> : <></>}
                                </Col>
              </Row>
            </Block>
          </Page>
        </Popup>
      </>
    );
  }
}
